function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpIcon = function SvgHelpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144.05 145.15"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M106.37 93.86a3.89 3.89 0 0 0-3.87 3.9l.19 43.53a3.88 3.88 0 0 0 7.76 0l-.19-43.54a3.88 3.88 0 0 0-3.89-3.89Z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6 25a38.29 38.29 0 0 0-4.53 76.29v-4.53a5.27 5.27 0 0 1 1-3.16 30.51 30.51 0 1 1 8.49-.15 5.3 5.3 0 0 1 1.14 3.27v4.41A38.3 38.3 0 0 0 105.6 25ZM105 18h7V0H40v7h65v11zM7 37H0v108h95v-7H7V37z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5 86a3.5 3.5 0 0 0 0-7H24v40h63.5a3.5 3.5 0 0 0 0-7H31V86ZM26.5 63h30a3.5 3.5 0 0 0 0-7h-30a3.5 3.5 0 0 0 0 7ZM29.5 11.5V1L2 26.5h10.5l17-15z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ad112b"
    },
    d: "M38 0h-7v28H0v7h38V0z"
  }));
};
export default SvgHelpIcon;